import {unminifyBrand, unminifyDivision, unminifyCategory, unminifySubcategory, unminifySub2, unminifyFabrication, unminifyColor, unminifyPacks, unminifyAccountName, unminifySizes, unminifySeason, _atsRep} from '../cads/unminify'
import {expandDivisions} from './options'
import {processText} from '../new-vpo-page/select-cads/process-text'
import {sortAndRemoveTaken, addDaysToDate, getDate} from './vendor-order-dates'
import {checkFutureAtsMonths} from '../cads/future_ats_months'
import {filterSalesOrders, filterShippedOrders} from './filter-sales-orders'
import {BAD_STYLE_NUMBERS} from '../../modules/constants'
import {_sites} from './card'
import {isPoeOrder} from './poe-chip-popup'
import {getTicketInfoFor} from './ticket-chip-popup'
import {needsTickets} from '../purchase-orders/needs-tickets'

const BRAND_ALIASES = {
  'PARIS HILTON': ['PARIS HILTON', 'PARIS HILTON GIRLS', 'PARIS HILTON BABY'],
}

//tabs where the cards come from orders, so the Rep filter means the rep on the order
const ORDER_STATUSES = ['Shipped', 'PO', 'Pending PO', 'Ready To Ship', 'Hold', 'Worksheet']

const hasNonLatinCharacters = (str) => {
  const regex = /\P{Script_Extensions=Latin}/u;
  return regex.test(str.replaceAll('-', '').replaceAll(/[0-9]/g, "").replaceAll(" ", "").replaceAll("'", "").replaceAll("/", "").replaceAll("(", "").replaceAll(")", "").replaceAll(".", "").replaceAll(",", "").replaceAll("&", ""))
}

const cadMatchesSearch = (x, searchStrings, vendorOrders, receivedContainers, salesOrderData, shippedData, estimates) => {
  let description = (x.v || '').toLowerCase()

  return (
    searchStrings.includes(x.s)
    ||
    searchStrings.some(y => y.length > 3 && x.s.includes(y))
    ||
    searchStrings.some(y => y.length > 3 && description.includes(y.toLowerCase()))
    ||
    (
      vendorOrders != null
      &&
      vendorOrders.some(y => y.style_number == x.s && (
        searchStrings.includes(y.container_number)
        ||
        (y.pending_container_number != null && y.pending_container_number.split(',').map(s => s.trim()).some(c => searchStrings.includes(c)))
      ))
    )
    ||
      (x.cn != null && x.cn.split('@@@').some(c => searchStrings.includes(c)))
    ||
      ((receivedContainers || {})[x.s] || []).some(row => searchStrings.includes(row[1]) || searchStrings.includes(row[0]))
    ||
      (salesOrderData[x.s] != null && salesOrderData[x.s].some(y => searchStrings.includes(y.ponumber)))
    ||
      (salesOrderData[x.i] != null && salesOrderData[x.i].some(y => searchStrings.includes(y.ponumber)))
    ||
      (shippedData[x.s] != null && shippedData[x.s].some(y => searchStrings.includes(y.p)))
    ||
      (estimates != null && estimates[x.s] != null && estimates[x.s].some(y => searchStrings.includes(y.ponumber)))
  )
}

const isPendingPi = (cad, vendorOrders) => {
  if (cad.ppi) return true

  return vendorOrders.some(x =>
    x.style_number == cad.s && (x.factory_id || '').toUpperCase().includes('PENDING PI')
  )
}

const filterCads = (myState, usingFilters, maxUnits, maxDays) => {
  let {
    cads, brand, division, category, subcategory, sub2, fabrication, color, packs, minAts, maxAts, minFutureAts,
    maxFutureAts, minAge, maxAge, minOnHand, maxOnHand, minPendingPo, maxPendingPo, hasShipped, shippedData, searchString, hasSalesOrder,
    salesOrderData, estimates, hasHold, contact, status, sizes, season, futureAts, vendorOrders, receivedContainers,
    fromDate, toDate, atsRep, rep, groupId, warehouse, factory, laFashionCombine, combinedCads,
    poeInfo, ticketInfo
  } = myState
  let filteredCads = [], searchStrings = []
  let notFoundStyleNumbers = []
  let customAccess = JSON.parse(localStorage.getItem('customAccess'))
  let foundPoNumber = null

  if (usingFilters) {
    if (laFashionCombine) {
      filteredCads = (combinedCads || []).slice()
    } else {
      filteredCads = cads.slice()
    }

    if (searchString != '') {
      searchStrings = processText(searchString)

      foundPoNumber = Object.values(salesOrderData).flat().filter(x => searchStrings.includes(x.ponumber))[0]

      if (estimates != null) {
        foundPoNumber = Object.values(estimates).flat().filter(x => searchStrings.includes(x.ponumber))[0]
      }

      if (foundPoNumber == null) {
        foundPoNumber = Object.values(shippedData).flat().filter(x => searchStrings.includes(x.p))[0]
        if (foundPoNumber != null) {
          foundPoNumber['shipped'] = true
        }
      }

      filteredCads = filteredCads.filter(x => cadMatchesSearch(x, searchStrings, vendorOrders, receivedContainers, salesOrderData, shippedData, estimates))

      let uniqueSearchStrings = [...new Set(searchStrings.filter(t => t != ''))]
      if (uniqueSearchStrings.length > 1) {
        notFoundStyleNumbers = uniqueSearchStrings.filter(t =>
          !filteredCads.some(x => cadMatchesSearch(x, [t], vendorOrders, receivedContainers, salesOrderData, shippedData, estimates))
        )
      }
    }

    if (brand.length) {
      const selected = brand.map(b => b.includes(' = ') ? b.split(' = ')[1] : b)
      const expanded = selected.flatMap(b => BRAND_ALIASES[b] || [b])
      filteredCads = filteredCads.filter(x => expanded.includes(unminifyBrand(x.b)))
    } else if (customAccess != null && customAccess.brand != null) {
      filteredCads = filteredCads.filter(x => customAccess.brand.includes(unminifyBrand(x.b)))
    }

    if (division.length) {
      filteredCads = filteredCads.filter(x => expandDivisions(division).includes(unminifyDivision(x.d)))
    } else if (customAccess != null && customAccess.division) {
      filteredCads = filteredCads.filter(x => customAccess.division.includes(unminifyDivision(x.d)))
    }

    if (category.length) {
      filteredCads = filteredCads.filter(x => category.map(x => x.includes(' = ') ? x.split(' = ')[1] : x).includes(unminifyCategory(x.g)))
    } else if (customAccess != null && customAccess.category) {
      filteredCads = filteredCads.filter(x => customAccess.category.includes(unminifyCategory(x.g)))
    }

    if (subcategory.length) {
      filteredCads = filteredCads.filter(x => subcategory.includes(unminifySubcategory(x.e)))
    }

    if (sub2.length) {
      filteredCads = filteredCads.filter(x => sub2.includes(unminifySub2(x.n)))
    }

    if (fabrication.length) {
      filteredCads = filteredCads.filter(x => atsRep[x.i] != null && fabrication.includes(unminifyFabrication(atsRep[x.i].f)))
    }

    if (sizes.length) {
      filteredCads = filteredCads.filter(x => atsRep[x.i] != null && sizes.includes(unminifySizes(atsRep[x.i].s)))
    }

    if (season.length) {
      filteredCads = filteredCads.filter(x => (x.l == null || x.l === '')
        ? season.includes('Missing')
        : season.includes(unminifySeason(x.l)))
    }

    if (packs.length) {
      filteredCads = filteredCads.filter(x => packs.map(x => x.includes(' = ') ? x.split(' = ')[1] : x).includes(unminifyPacks(x.p)))
    }

    if (color.length) {
      filteredCads = filteredCads.filter((x) => {
        const wantsMissing = color.includes('MISSING')
        const array1 = color.filter(c => c !== 'MISSING').map(x => x.includes(' = ') ? x.split(' = ')[1] : x)
        const array2 = _colors(x)

        const isMissing = array2.length === 0

        if (wantsMissing && isMissing) return true
        return array1.some(item => array2.includes(item))
      })
    }

    if (status == 'Oversold') {
      if (minFutureAts > 0) {
        filteredCads = filteredCads.filter(x => -1 * x.u >= roundTens(minFutureAts))
      }

      if (maxFutureAts < maxUnits) {
        filteredCads = filteredCads.filter(x => -1 * x.u <= roundTens(maxFutureAts))
      }
    } else {
      if (minAts > 0 || minFutureAts > 0 || maxAts < maxUnits || maxFutureAts < maxUnits) {
        filteredCads = filteredCads.filter((x) => {
          let currentOK = (minAts == 0 || x.a >= roundTens(minAts)) && (maxAts == maxUnits || x.a <= roundTens(maxAts))

          if (minAts == 0 && maxAts == maxUnits && !['ATS', 'ATS or Future ATS'].includes(status)) {
            currentOK = false
          }

          let futureOK = (minFutureAts == 0 || x.u >= roundTens(minFutureAts)) && (maxFutureAts == maxUnits || x.u <= roundTens(maxFutureAts))

          if (minFutureAts == 0 && maxFutureAts == maxUnits && !['ATS or Future ATS', 'Future ATS'].includes(status)) {
            futureOK = false
          }

          if ((x.u == null || x.u == 0) && minFutureAts == 0 && status == 'ATS or Future ATS') {
            futureOK = false
          }

          return currentOK || futureOK
        })
      }
    }

    if (minAge > 0) {
      filteredCads = filteredCads.filter(x => x.m >= roundTens(minAge))
    }

    if (maxAge < maxDays) {
      filteredCads = filteredCads.filter(x => x.m <= roundTens(maxAge))
    }

    if (minOnHand > 0) {
      filteredCads = filteredCads.filter(x => x.y >= roundTens(minOnHand))
    }

    if (maxOnHand < maxUnits) {
      filteredCads = filteredCads.filter(x => x.y <= roundTens(maxOnHand))
    }

    if (minPendingPo > 0 || maxPendingPo < maxUnits) {
      filteredCads = filteredCads.filter((x) => {
        let orders = filterSalesOrders(salesOrderData, x, contact, fromDate, toDate)
        if (estimates != null) {
          orders = filterSalesOrders(estimates, x, contact, fromDate, toDate)
        }
        let qty = orders.filter(y => y.pending_po).reduce((a, y) => a + Number(y.quantity), 0)
        return (minPendingPo == 0 || qty >= roundTens(minPendingPo)) && (maxPendingPo == maxUnits || qty <= roundTens(maxPendingPo))
      })
    }

    if (status != null) {
      switch (status) {
      case 'On Hand':
        filteredCads = filteredCads.filter(x => x.y > 0)
        break;
      case 'ATS':
        filteredCads = filteredCads.filter(x => x.a > 0)
        break;
      case 'ATS Rep':
      case 'Sizes':
      case 'Cost':
      case 'Fabrication':
        filteredCads = filteredCads.filter(x => x.a > 0 && atsRep[x.i] != null)
        break;
      case 'ATS or Future ATS':
        filteredCads = filteredCads.filter(x => x.a > 0 || x.u > 0)
        break;
      case 'Best Seller':
        filteredCads = filteredCads.filter(x => x.x > 0)
        break;
      case 'Average Seller':
        filteredCads = filteredCads.filter(x => x.av > 0)
        break;
      case 'Poor Seller':
        filteredCads = filteredCads.filter(x => x.z > 0)
        break;
    case 'Reviewed':
      filteredCads = filteredCads.filter(x => x.br > 0)
      break;
      case 'Future Stock':
        filteredCads = filteredCads.filter(x => x.w > 0)
        break;
      case 'Future ATS':
        filteredCads = filteredCads.filter(x => x.u > 0)
        break;
      case 'Pending PI':
        filteredCads = filteredCads.filter(x => isPendingPi(x, vendorOrders))
        break;
      case 'Loading Date':
        filteredCads = filteredCads.filter((cad) => {
          let orders = vendorOrders.filter(x => x.style_number == cad.s && x.loading_date != null)
          return orders.length
        })
        break;
      case 'Shipped':
        filteredCads = filteredCads.filter((x) => {
          let styles = x.cads == null ? [x.s] : x.cads.map(c => c.s)
          let orders = styles.reduce((rows, style) => rows.concat(shippedData[style] || []), [])
          orders = filterShippedOrders(orders, contact, fromDate, toDate)
          return orders.length > 0
        })
        break;
      case 'PO':
        filteredCads = filteredCads.filter((x) => {
          let orders = filterSalesOrders(salesOrderData, x, contact, fromDate, toDate)
          if (estimates != null) {
            orders = filterSalesOrders(estimates, x, contact, fromDate, toDate)
          }
          return orders.some(y => !y.hold && !y.worksheet && !y.pending_po)
        })
        break;
      case 'Pending PO':
        filteredCads = filteredCads.filter((x) => {
          let orders = filterSalesOrders(salesOrderData, x, contact, fromDate, toDate)
          if (estimates != null) {
            orders = filterSalesOrders(estimates, x, contact, fromDate, toDate)
          }
          return orders.some(y => y.pending_po)
        })
        break;
      case 'Ready To Ship':
        filteredCads = filteredCads.filter((x) => {
          let orders = filterSalesOrders(salesOrderData, x, contact, fromDate, toDate)
          if (estimates != null) {
            orders = filterSalesOrders(estimates, x, contact, fromDate, toDate)
          }
          return orders.some(y => !y.hold && !y.worksheet && !y.pending_po) && x.y > 0
        })
        break;
      case 'Hold':
        filteredCads = filteredCads.filter((x) => {
          let orders = filterSalesOrders(salesOrderData, x, contact, fromDate, toDate)
          if (estimates != null) {
            orders = filterSalesOrders(estimates, x, contact, fromDate, toDate)
          }
          return orders.some(y => y.hold)
        })
        break;
      case 'Worksheet':
        filteredCads = filteredCads.filter((x) => {
          let orders = filterSalesOrders(salesOrderData, x, contact, fromDate, toDate)
          if (estimates != null) {
            orders = filterSalesOrders(estimates, x, contact, fromDate, toDate)
          }
          return orders.some(y => y.worksheet)
        })
        break;
      case 'No Image':
        filteredCads = filteredCads.filter(x => x.f == null)
        break;
      case 'Age':
        filteredCads = filteredCads.filter(x => x.m != null)
        break;
      case 'Season':
        filteredCads = filteredCads.filter(x => x.l != null)
        break;
      case 'Container #':
        filteredCads = filteredCads.filter((cad) => {
          return vendorOrders.filter(x => x.style_number == cad.s && x.container_number != null).length > 0
            || ((receivedContainers || {})[cad.s] || []).length > 0
        })
        break;
      case 'Future ATS Confirmed':
        filteredCads = filteredCads.filter((cad) => {
          let hasFutureAts = cad.u >= 25

          if (hasFutureAts) {
            return !isPendingPi(cad, vendorOrders)
          } else {
            return false
          }
        })
        break;
      case 'Group ID':
        if (groupId == null) {
          filteredCads = filteredCads.filter(x => x.q != null)
        } else {
          filteredCads = filteredCads.filter(x => x.q == groupId)
        }
        break;
      case 'Non Latin Characters':
        filteredCads = filteredCads.filter(x => hasNonLatinCharacters(x.s))
        break;
      case 'Duplicate VPO':
        filteredCads = filteredCads.filter((cad) => {
          let orders =  vendorOrders.filter(x => x.style_number == cad.s)

          const ponumbers = orders.map(x => `${x.vponumber}-${x.qty}`)
          const uniquePonumbers = [...new Set(ponumbers)]

          return ponumbers.length != uniquePonumbers.length
        })
        break;
      case 'Do Not Sell':
        filteredCads = filteredCads.filter(x => BAD_STYLE_NUMBERS.includes(x.s))
        break;
      case 'Warehouse':
        filteredCads = filteredCads.filter(x => x.k != null)
        break;
      case 'Oversold':
        filteredCads = filteredCads.filter(x => x.u < 0)
        break;
      case 'POE':
        //a cad passes if ANY of its orders is POE
        filteredCads = filteredCads.filter(x =>
          (salesOrderData[x.s] || []).concat(salesOrderData[x.i] || [])
            .some(o => isPoeOrder(poeInfo, o.ponumber))
        )
        break;
      case 'Ticketed PO':
        //a cad passes if ANY of its sales orders needs tickets
        filteredCads = filteredCads.filter(x =>
          (salesOrderData[x.s] || []).concat(salesOrderData[x.i] || [])
            .some(o => getTicketInfoFor(ticketInfo, o.ponumber) != null)
        )
        break;
      case 'Ticketed VPO': {
        //build the style set once — scanning vendorOrders per cad is too slow
        const ticketedStyles = new Set(
          (vendorOrders || []).filter(v => needsTickets(v.ticketed)).map(v => v.style_number)
        )
        filteredCads = filteredCads.filter(x => ticketedStyles.has(x.s))
        break;
      }
      case 'Sub2':
        filteredCads = filteredCads.filter(x => x.n != null)
        break;
      default:
        // Code to be executed if no case matches
      }
    }

    if (rep != null && rep != 'All') {
      if (ORDER_STATUSES.includes(status)) {
        //on order based tabs the rep is whoever is on the order. atsRep is the vendor order
        //rep and only exists while a style still has units, so it drops anything sold out
        filteredCads = filteredCads.filter((x) => {
          if (status == 'Shipped') {
            let styles = x.cads == null ? [x.s] : x.cads.map(c => c.s)
            let orders = styles.reduce((rows, style) => rows.concat(shippedData[style] || []), [])
            return filterShippedOrders(orders, contact, fromDate, toDate, rep).length > 0
          }

          let orders = filterSalesOrders(salesOrderData, x, contact, fromDate, toDate, rep)
          if (estimates != null) {
            orders = filterSalesOrders(estimates, x, contact, fromDate, toDate, rep)
          }
          return orders.length > 0
        })
      } else {
        filteredCads = filteredCads.filter(x => atsRep[x.i] != null && _atsRep(atsRep[x.i].r) == rep)
      }
    }

    if (warehouse.length) {
      filteredCads = filteredCads.filter(x => warehouse.some(y => _sites(x).includes(y)))
    }

    if (factory.length) {
      filteredCads = filteredCads.filter((cad) => {
        let orders = vendorOrders.filter(x => x.style_number == cad.s)
        if (orders.some(x => factory.includes(x.factory_id))) {
          return true
        }

        return false
      })
    }

    if (futureAts.length) {
      filteredCads = filteredCads.filter((cad) => {
        let orders = vendorOrders.filter(x => x.style_number == cad.s)
        if (orders.length) {
          orders = sortAndRemoveTaken(orders, cad)
          let dates = orders.map((x) => {
            const isLoading = x.loading_date != null
            return addDaysToDate(getDate(isLoading ? x.loading_date : x.ex_factory), isLoading)
          })

          for (let k=0; k < dates.length; k++) {
            let year = dates[k].getFullYear()
            let month = dates[k].getMonth()+1

            for (let i=0; i < futureAts.length ; i++) {
              if (checkFutureAtsMonths(month, year, futureAts[i])) {
                return true
              }
            }
          }
        }
        return false
      })
    }

  }

  return {filteredCads, foundPoNumber, notFoundStyleNumbers}
}

const _colors = (cad) => {
  if (cad.r == null || cad.r === '' || cad.r === '[]') return []
  if (typeof cad.r === 'string' && cad.r.slice(0,2) == '["') {
    const parsed = JSON.parse(cad.r)
    return parsed.length === 0 ? [] : parsed
  } else {
    return [unminifyColor(cad.r)]
  }

}

const roundTens = (num) => {
  if (num > 1000) {
    return Math.round(num / 1000.0) * 1000.0
  } else if (num > 100) {
    return Math.round(num / 100.0) * 100.0
  } else if (num < 20 && num > 0) {
    return 1
  } else {
    return Math.round(num / 10.0) * 10.0
  }

}

export {filterCads, roundTens}
